import { Injectable, Inject, PLATFORM_ID,Optional } from '@angular/core';
import { HttpService } from '../../http/http.service';
import { AccountService } from '../../api-services/accout';
import { Observable } from 'rxjs';
import {  tap } from "rxjs/operators";
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';


//========================
import { isPlatformBrowser } from '@angular/common';
import { REQUEST, RESPONSE } from '@nguniversal/express-engine/tokens';
import { env } from 'process';
import { environment } from '@env';

@Injectable({
  providedIn: 'root'
})
export class IndexdbService {
    private isBrowser: boolean;
    rawHttp: any;
    constructor(
      private accountService: AccountService, 
      private httpBackend: HttpBackend,
      private cookieService: CookieService,
      @Inject(PLATFORM_ID) platformId: Object,
      @Optional() @Inject(REQUEST) private request: any,
      @Optional() @Inject(RESPONSE) private response: any
    ) {
        this.rawHttp = new HttpClient(httpBackend);
        this.isBrowser = isPlatformBrowser(platformId);
     }

//   getCryptoKey() {
//     let req = { _ip: "13123123123" };
//     this.accountService.createCommunicationConntion(req).subscribe({
//       next: (result: any) => {
//         let CPrivateKey = result.headers.get("c-pvkey");
//         let sPublicKey = result.headers.get("s-pbkey");
//         let AesKey = result.headers.get("x-aes");

//         let data = {
//           id: 1111,
//           key: `${CPrivateKey}|${sPublicKey}|${AesKey}`,
//         };
//         this.saveCryptoKeyInLocalStorage(data.key);
//         this.saveUser(data).then(() => {
       
//           //this.OnLogin()
//         });
//       },
//       error: (error) => {
//         console.error(error);
//       },
//     });
//   }


getCryptoKey(): Observable<any> {
let url=`${environment.API_BASE_PATH}api/Key/public`;
  const headers = new HttpHeaders()
  //.set("X-ip", '12345678')
   .set("accept", "application/json, text/plain")
    .set("responseType","text" as const);
  return this.rawHttp.post(url,{},{headers,observe: 'response', withCredentials: true, responseType: 'text' as 'json'}).pipe(
    tap((result: any) => {
      const CPrivateKey = result.headers.get("c-pvkey");
      const sPublicKey = result.headers.get("s-pbkey");
      const AesKey = result.headers.get("x-aes");

      const data =   `${CPrivateKey}|${sPublicKey}|${AesKey}`;

      this.saveCryptoKeyInLocalStorage(data);
    })
  );
}


  // Open (or create) the database
  openDB() {
    return new Promise((resolve, reject) => {
      const request = indexedDB.open("MyDatabase", 1);

      request.onupgradeneeded = function (event: any) {
        const db = event.target.result;
        if (!db.objectStoreNames.contains("users")) {
          db.createObjectStore("users", { keyPath: "id", autoIncrement: true });
        }
      };

      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject("Error opening DB");
    });
  }

  // ✅ Add or Update User
  async saveUser(user: any) {

    const db: any = await this.openDB();
    const tx = db.transaction("users", "readwrite");
    const store = tx.objectStore("users");
    store.put(user);
    return new Promise((resolve, reject) => {
      tx.oncomplete = () => resolve(true);
      tx.onerror = () => reject(tx.error);
    });
  }

  // ✅ Get by ID
  async getUser(id: any) {
    const db: any = await this.openDB();
    const tx = db.transaction("users", "readonly");
    const store = tx.objectStore("users");
    return new Promise((resolve) => {
      const request = store.get(id);
      request.onsuccess = () => resolve(request.result);
    });
  }

  // ✅ Get All Users
  async getAllUsers() {
    const db: any = await this.openDB();
    const tx = db.transaction("users", "readonly");
    const store = tx.objectStore("users");
    return new Promise((resolve) => {
      const request = store.getAll();
      request.onsuccess = () => resolve(request.result);
    });
  }

  // ✅ Delete by ID
  async deleteUser(id: any) {
    const db: any = await this.openDB();
    const tx = db.transaction("users", "readwrite");
    const store = tx.objectStore("users");
    store.delete(id);
    return new Promise((resolve) => {
      tx.oncomplete = () => resolve(true);
    });
  }

  // ✅ Clear all users
  async clearUsers() {
    const db: any = await this.openDB();
    const tx = db.transaction("users", "readwrite");
    const store = tx.objectStore("users");
    store.clear();
    return new Promise((resolve) => {
      tx.oncomplete = () => resolve(true);
    });
  }


  saveCryptoKeyInLocalStorage(data){
  
     const days = 1;
     this.cookieService.set('ckey', data, days, '/', environment.cookieDomain, true, 'None');
  }


 

  getCookie(name: string): string {
    if (this.isBrowser) {
      return this.cookieService.get(name); // ❌ won't return HttpOnly
    } else {
      return this.request?.cookies?.[name] || ''; // ✅ HttpOnly works here
    }
    
  }

  deleteCookie(key){
    if (this.isBrowser) {
      this.cookieService.delete(key)
    } else {
      this.response.clearCookie(key, {
        path:'/',
        domain:environment.cookieDomain,
        secure:true,
        sameSite:'None',
        httpOnly:false
      });
    }
   
  }

getCryptoKeyFromLocalStorage() {
  return new Promise(async (resolve, reject) => {
    try {
      const ckeyValue = await this.getCookie('ckey');

      // Validate the fetched value
      if (!ckeyValue || typeof ckeyValue !== 'string') {
        console.error('Invalid or missing ckey value:', ckeyValue);
        reject('Invalid or missing ckey value');
        return;
      }

      resolve(ckeyValue);
    } catch (error) {
      console.error('Error fetching ckey from cookie:', error);
      reject(error);
    }
  });
}

  // getCryptoKeyFromLocalStorage(){
  //   return new Promise(async (resolve) => {

  //     const ckeyValue = await this.getCookie('ckey');
  //     resolve(ckeyValue);
      
  //   });
  
  
 // }


 
}
